<template>
  <header
    class="fj-header d-f ai-c full-head"
    :class="isHome && isTransparent ? 'is-transparent' : 'bg-white'"
    ref="headerNav"
  >
    <svg-icon
      @click="$router.push({ path: '/' })"
      :icon-class="isHome && isTransparent ? 'fj-logo-w' : 'fj-logo'"
      class-name="fj-logo"
    />
    <nav class="fj-nav">
      <ul class="d-f ai-c">
        <li
          @mouseenter="navMouseenter($event, index)"
          @mouseleave="navMouseleave"
          v-for="(item, index) in $t('common.nav')"
          :class="index === 0 ? '' : 'p-r'"
          :key="index"
        >
          <span
            @click.stop="gotoRoute($event, item.url)"
            :class="isHome && isTransparent ? 'c-fff' : 'c-333'"
            class="nav-item"
            >{{ item.title }}</span
          >

          <ul class="p-a bgc-fff nav-children-warp" v-show="isShow && activeIndex === index && activeIndex !== 0">
            <li
              class="nav-children-item"
              v-for="subItem in item.children"
              :key="subItem.id"
              @click="jumpRoute(subItem)"
            >
              <!-- <AppLink :to="subItem.url">{{ subItem.title }} </AppLink> -->
              {{ subItem.title }}
            </li>
          </ul>
          <ul
            v-show="isShow && activeIndex === index && activeIndex === 0"
            class="full-head-nav-product p-a w-100p fw-w bgc-fff"
          >
            <li
              v-for="(productItem, itemIdx) in $t('common.nav')[0]['children']"
              :key="productItem.id"
              class="full-head-nav-catalog d-f"
            >
              <div class="full-head-nav-product-list">
                <AppLink :to="productItem.href" class="full-head-nav-strong">{{ productItem.industryName }}</AppLink>
                <div
                  class="full-head-nav-product-list-a fs-14"
                  v-for="productSubItem in productItem.industrys"
                  :key="productSubItem.title"
                  @mouseenter="showProductImg(productSubItem, itemIdx)"
                >
                  <AppLink :to="productSubItem.href" class="c-26 product-sub-item-name">{{
                    productSubItem.title
                  }}</AppLink>
                </div>
              </div>
              <img
                :id="`product-${itemIdx}`"
                class="full-head-nav-product-img"
                v-lazy="$t('common.nav')[0]['children'][itemIdx].imgSrc"
                alt=""
                srcset=""
              />
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <div class="right-menu search-language d-f ai-c">
      <!-- <svg-icon :icon-class="isHome && isTransparent ? 'search-w' : 'search'" class-name="nav-logo" /> -->
      <Dropdown v-if="langs !== 'zh'" @on-click="selectLang">
        <svg-icon
          :icon-class="isHome && isTransparent ? `${$i18n.locale}-lang-w` : `${$i18n.locale}-lang`"
          class-name="lang-logo"
        />
        <DropdownMenu slot="list">
          <DropdownItem v-for="lang in selectLangArr" :key="lang" :name="lang">{{ langArr[lang] }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <a
        href="https://store.fjdynamics.com/?utm_source=fjdynamics&utm_medium=ctr&utm_campaign=website_shopping_cart&utm_id=website_0802"
        target="_blank"
      >
        <svg-icon :icon-class="isHome && isTransparent ? 'nav-shop-w' : 'nav-shop'" class-name="nav-logo" />
      </a>
    </div>
  </header>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { langRoute } from '@/config/language'
  import AppLink from '@/components/AppLink'
  export default {
    name: 'FjNavBar',
    components: {
      AppLink
    },
    data() {
      return {
        isShow: false,
        activeIndex: 0,
        timer: null,
        productImg: '',
        // isTransparent: true,
        // isShowNav: true,
        // bannerHeigth: 800,
        windowScrollY: 0, // 浏览器滚动距离
        showAnim: null,
        isHome: true,
        langArr: {
          en: 'English',
          sv: 'Svenska',
          jp: 'Japanese',
          ru: 'Русский',
          es: 'Español',
          pt: 'Português',
          fr: 'français',
          de: 'Deutsch',
          tr: 'Türkçe',
          pl: 'Polska'
        }
      }
    },
    computed: {
      langs() {
        return process.env.LANG
      },
      ...mapGetters({
        isTransparent: 'isTransparent',
        isWhite: 'isWhite'
      }),
      selectLangArr() {
        return Object.keys(this.langArr).filter((item) => item !== this.$i18n.locale)
      }
    },
    watch: {
      '$route.name': {
        handler(val, oldVal) {
          if (val === oldVal) return
          // this.isTransparent = langRoute.some((lang) => val === `index___${lang}`)
          const isTransparent = langRoute.some((lang) => val === `index___${lang}`)
          // 首页才需要透明
          this.isHome = isTransparent
          this.$store.commit('scrollNavBg', isTransparent)
          // 切换路由 导航栏隐藏
          this.isShow = false
        },
        immediate: true
      }
    },
    mounted() {},

    methods: {
      navMouseenter(e, index) {
        // this.isTransparent = false
        this.$store.commit('scrollNavBg', false)
        this.$store.commit('processShowSubNav', true)
        this.isShow = true
        this.activeIndex = index

        if (this.timer) {
          clearTimeout(this.timer)
        }
      },

      navMouseleave() {
        console.log('[ "navMouseleave" ] >', 'navMouseleave')
        if (langRoute.some((lang) => this.$route.name === `index___${lang}`)) {
          // this.isTransparent = true
          this.$store.commit('scrollNavBg', true)
          this.$store.commit('processShowSubNav', false)
        }

        this.timer = setTimeout(() => {
          this.isShow = false
          this.timer = null
        }, 100)
      },
      showProductImg({ imgSrc, alt }, idx) {
        const activeImg = document.getElementById(`product-${idx}`)
        activeImg.src = imgSrc
        activeImg.alt = alt
        // this.productImg = imgSrc
      },
      gotoRoute(e, route) {
        e.stopPropagation()
        // console.log('[  route] >', route)
        this.$router.push(route)
      },
      // 除产品页面跳转
      jumpRoute({ url, query, hash }) {
        const routeParams = { path: url }
        console.log('[ hash ] >', hash)
        if (hash) routeParams['hash'] = hash

        if (query) routeParams['query'] = { name: query }

        console.log('[ routeParams ] >', routeParams)

        this.$router.push(routeParams)
      },
      // 切换语种
      selectLang(locale) {
        // console.log('[ locale ] >', )
        this.$i18n.setLocale(locale)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-transparent {
    background: transparent;
  }

  .fj-header {
    height: 0.76rem;
    box-sizing: border-box;
    width: 100%;
    padding: 0 3.125vw;
    position: fixed;
    z-index: 999;
    -webkit-font-smoothing: antialiased​​;
    // transition: all 0.2s;
    // &:hover {
    //   background: #fff !important;
    // }
    .fj-logo {
      cursor: pointer;
      width: 1.19rem;
      height: 0.3rem;
    }
  }
  .fj-nav {
    margin-left: 0.8rem;
    flex: 1;
    .nav-item {
      margin: 0 0.25rem;
      font-size: 0.14rem;
      cursor: pointer;
      line-height: 0.76rem;
      position: relative;
      white-space: nowrap;
      display: inline-block;
      // transform: perspective(1px) translateZ(0);
      -webkit-font-smoothing: antialiased;

      &:hover:before {
        right: 0;
      }
      &:before {
        content: '';
        position: absolute;
        z-index: -1;
        left: 0;
        right: 100%;
        bottom: 0;
        background: #333;
        height: 2px;
        transition-property: right;
        transition-duration: 0.3s;
        transition-timing-function: ease-out;
      }
      &:after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: '';
        display: block;
        height: 2px;
        width: 0;
        margin-top: 8px;
        background-color: #333;
        will-change: width;
        margin-bottom: -1px;
        transition-timing-function: ease-out;
      }
    }
  }
  .nav-children-warp {
    box-shadow: 0rem 0.12rem 0.38rem -0.1rem rgb(0 0 0 / 10%), 0rem 0.09rem 0.3rem -0.16rem rgb(0 0 0 / 10%);
    border-radius: 0.04rem;
    padding: 0.12rem 0;
    margin-right: 0.25rem;
    left: 50%;
    transform: translateX(-50%);
    -webkit-font-smoothing: antialiased​​;
    top: 0.85rem;
  }
  // product 菜单
  .full-head-nav-product {
    // transition: opacity 0.3s linear;
    // will-change: opacity;
    display: flex;
    // opacity: 0;
    // height: 0;
    left: 0;
    top: 0.76rem;
    -webkit-font-smoothing: antialiased​​;
    box-shadow: 0px 12px 38px -10px rgba(0, 0, 0, 0.1), 0px 9px 30px -16px rgba(0, 0, 0, 0.1);
    // overflow: hidden;
    .full-head-nav-catalog {
      width: calc(50% - 1px);
      padding: 1vw 0;
      border-bottom: 1px solid #efefef;
      border-right: 1px solid #efefef;
      box-sizing: border-box;
      align-items: center;
      &:nth-child(2n) {
        border-right: none;
      }
      &:last-child {
        border-bottom: 1px solid transparent;
      }
      &:hover {
        cursor: pointer;
        background: #fafafa;
      }
    }
    .full-head-nav-product-list {
      width: 17vw;
      // margin-right: 1.6rem;
      margin-left: 1.8rem;
    }
    .full-head-nav-product-list-a {
      cursor: pointer;
      white-space: nowrap;
    }
    .full-head-nav-strong {
      display: block;
      padding-bottom: 0.22rem;
      font-size: 0.18rem;
      font-weight: 700;
      color: #333;
      cursor: pointer;
    }
    .full-head-nav-product-img {
      width: 3.56rem;
      height: 2.18rem;
    }
    .product-sub-item-name {
      transition: text-indent 0.3s linear;
      will-change: text-indent;
      float: left;
      clear: both;
      margin-top: 0.18rem;
      color: #666666;
      font-size: 0.14rem;
      cursor: pointer;
      &:hover {
        text-indent: 12px;
        color: #333;
      }
      &:hover:after {
        transition: width 0.3s ease-out;
        width: 100%;
      }
      &:after {
        content: '';
        display: block;
        height: 2px;
        width: 0;
        margin-top: 8px;
        background-color: #333;
        will-change: width;
      }
    }
  }

  .nav-children-item {
    position: relative;
    transform: perspective(1px) translateZ(0px);
    transition: all 0.3s linear;
    display: block;
    line-height: 0.4rem;
    padding: 0 0.25rem;
    white-space: nowrap;
    background-color: transparent;
    font-size: 0.14rem;
    color: #333;
    cursor: pointer;
    &:before {
      position: absolute;
      display: block;
      content: '';
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: -1;
      transition: transform 0.2s ease-out;
      transform-origin: 0 0;
      transform: scaleX(0);
      background-color: #f0f0f0;
      overflow: hidden;
    }
    &:hover:before {
      transform: scaleX(1);
    }
  }

  .right-menu {
    // align-self: flex-end;
    width: 1.04rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .lang-logo {
      width: 24px;
      height: 24px;
      box-sizing: border-box;
      transition: transform 0.3s linear;
      will-change: transform;
      cursor: pointer;
      &:hover {
        transform: scale(1.2);
      }
    }
    .nav-logo {
      width: 20px;
      height: 20px;
      box-sizing: border-box;
      transition: transform 0.3s linear;
      will-change: transform;
      cursor: pointer;
      &:hover {
        transform: scale(1.2);
      }
    }
    :deep(.ivu-dropdown) {
      height: 20px;
      margin-bottom: 2px;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
